import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-secondary-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Left label */}
          <div className="lg:col-span-1">
            <p className="text-xs tracking-widest uppercase text-foreground-400 font-label">
              About the System
            </p>
          </div>

          {/* Right content */}
          <div className="lg:col-span-4">
            <div className="max-w-3xl">
              <p className="text-lg md:text-xl text-foreground-800 leading-relaxed mb-6">
                <strong className="text-foreground-900">GTBuy Spreadsheet</strong> is a next-generation spreadsheet system designed for users who manage product sourcing through platforms like <strong className="text-foreground-900">Kakobuy</strong> and <strong className="text-foreground-900">Superbuy</strong>. It transforms the way you handle product data, giving you complete control over your sourcing workflow with minimal effort.
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                Unlike traditional manual tracking methods, the GTBuy Spreadsheet system automates repetitive data entry, enables real-time product comparison across multiple suppliers, and provides intelligent categorization that saves hours of work each week. Whether you are managing a small curated collection or scaling to thousands of SKUs, this system adapts to your needs.
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8">
                From <strong className="text-foreground-900">tracking product orders in real-time</strong> to <strong className="text-foreground-900">comparing suppliers and pricing</strong>, the spreadsheet automation tools built into the platform reduce manual data entry errors and help you scale your sourcing operations efficiently. Learn more about how this system works on our{" "}
                <Link
                  to="/article/gtbuy-spreadsheet-guide"
                  className="text-primary-500 hover:text-primary-600 underline underline-offset-2 transition-colors"
                >
                  detailed guide page
                </Link>
                .
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12 pt-10 border-t border-secondary-200/70">
              {[
                { num: "10K+", label: "Products Tracked" },
                { num: "99.9%", label: "System Uptime" },
                { num: "50+", label: "Countries Served" },
                { num: "24/7", label: "Platform Access" },
              ].map((stat) => (
                <div key={stat.label}>
                  <p className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-1">
                    {stat.num}
                  </p>
                  <p className="text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}